import React from "react";
import "./Commissions.scss";
import TabsList from "../Components/TabsList";
import { openImageModal } from "../Components/Modals";

let Data;

export default class Commissions extends React.Component {
	state = { data: null };

	async componentDidMount() {
		const res = await fetch("https://raw.githubusercontent.com/SerXia/Surreal-Studio/main/Commissions.json", {
			cache: "no-cache"
		});
		const data = await res.json();

		Commissions.Data = data;
		this.setState({ data });
	}

	render() {
		const { data } = this.state;
		const tabs = ["Standard", "Animated", "Pixel", "Emojis"];

		return (
			<div className="CommsPage">
				<div className="TabsContainer">
					<TabsList tabs={tabs}>
						{ data == null ? null : tabs.map(tab => (
							<div key={tab} tab={tab}>
								<Tab {...data[tab]}/>
							</div>
						)) }
					</TabsList>
				</div>
			</div>
		);
	}
}

class Tab extends React.Component {
	renderDescription(desc) {
		return (
			<div className="Description" dangerouslySetInnerHTML={{ __html:
				desc.replace(/\$\S*(?!$)/g, r => `<span class="Price">${ r }</span>`)
					.replace(/\(.*\)/g, r => `<span class="Group">${ r }</span>`)
					.replace(/\s[0-9](?=([^0-9]|$))/g, r => `<span class="Number">${ r }</span>`)
					.replace(/\n/g, "<br/>")
			}}/>
		);
	}

	render() {
		const { opened, items } = this.props;

		return (
			<div>
				<div className={"Status " + (opened ? "Opened" : "Closed")}>
					{ opened ? "OPEN" : "CLOSED" }
				</div>
				<div className="Status Desc">
					{ opened ? "Shading is free, just ask." : "Commissions are currently closed here, please check back later!" }
				</div>

				<div className="Items">
					{ items.map(item => {
						const { title, description, images } = item;

						return (
							<div className="CommissionItem">
								<div className="Title">{ title }</div>
								{ this.renderDescription(description) }
								
								<div className="Images">
									{ images.map(image => (
										<img key={image} src={"https://i.imgur.com/" + image} onClick={() => openImageModal("https://i.imgur.com/" + image)}/>
									)) }
								</div>
							</div>
						);
					}) }
				</div>
			</div>
		);
	}
}